import {generalRequest} from "@/lib/services/requests";
import {myAcademy} from "@/lib/services/academyService";
import {useMutation, useQuery} from "@tanstack/react-query";

export const gradeApi = {
    useAdminCreateGrade : () => {
        return useMutation({
            mutationFn: (args) =>
            {
                return generalRequest.post(`/admin/grades`, args);
            }
        });
    },
    useAdminGetGrade : (args) => {
        return useQuery({
            query: ['admin', 'grade', 'edit', args],
            queryFn: () => {
                return generalRequest.get(`/admin/grades/${args.id}`);
            },
        })
    },

    useAdminUpdateGrade : (args) => {
        return useMutation({
            mutationFn: (args) =>
            {
                return generalRequest.put(`/admin/grades/${args.id}`, args);
            }
        })
    }
}

export const useApiSearchAdminGrades = (config) => {
    return useQuery({
        queryKey: ['admin', 'grade', 'get', config, myAcademy()],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/grades`, config)
        })({params: config})),
    })
}


export const useApiSearchStudentGrade = (args = {}) => {
    return useQuery({
        queryKey: ['student', 'grade', 'list', args, myAcademy()],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/student/grades`, config)
        })({params: args})),
    })
}


export const useApiReadStudentGrade = (id) => {
    return useQuery({
        enabled: !!id,
        queryKey: ['student', 'grade', 'read', id, myAcademy()],
        queryFn: () => ((async (id = {}) => {
            return generalRequest.get(`/student/grades/${id}`)
        })(id)),
    })
}